var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 4.5999C7.913 4.5999 4.5999 7.913 4.5999 11.9999C4.5999 16.0868 7.913 19.3999 11.9999 19.3999C16.0868 19.3999 19.3999 16.0868 19.3999 11.9999C19.3999 7.913 16.0868 4.5999 11.9999 4.5999ZM3.3999 11.9999C3.3999 7.25025 7.25025 3.3999 11.9999 3.3999C16.7496 3.3999 20.5999 7.25025 20.5999 11.9999C20.5999 16.7496 16.7496 20.5999 11.9999 20.5999C7.25025 20.5999 3.3999 16.7496 3.3999 11.9999Z",
    fill: "#36B37E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8526 9.28999C16.0869 9.52431 16.0869 9.90421 15.8526 10.1385L11.3519 14.6392C11.0785 14.9126 10.6353 14.9126 10.3619 14.6392L8.14693 12.4242C7.91261 12.1899 7.91261 11.81 8.14693 11.5757C8.38124 11.3414 8.76114 11.3414 8.99546 11.5757L10.8569 13.4372L15.0041 9.28999C15.2384 9.05568 15.6183 9.05568 15.8526 9.28999Z",
    fill: "#36B37E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.e2e3473f0a7a3b822a46e6c001bb6a88.svg";
export { ForwardRef as ReactComponent };